/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorArticleTeaserBodytext as ResolvedLabradorArticleTeaserBodytext } from 'base/components/labrador/ArticleTeaser/Bodytext';

export const LabradorArticleTeaserBodytext: typeof ResolvedLabradorArticleTeaserBodytext = withLabradorInstanceof((props) => {
    return <ResolvedLabradorArticleTeaserBodytext {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorArticleTeaserBodytextProps = PropsFromComponent<typeof LabradorArticleTeaserBodytext>;
